var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"headerPagina"}},[_c('div',{staticClass:"barraTopo"},[_c('div',{staticClass:"flex3cols",staticStyle:{"width":"25%"}})])])}]

export { render, staticRenderFns }